import { defineSlotRecipe } from '@chakra-ui/react'

const white = 'brand.white'

export const footer = defineSlotRecipe({
  className: 'Footer',
  slots: [
    'container',
    'wrapper',
    'navList',
    'navListItem',
    'navListLink',
    'content',
    'legal',
    'logo',
    'logoWrapper',
  ],
  base: {
    wrapper: {
      backgroundColor: 'brand.primary.midnightBlue',
      color: white,
    },
    navListLink: {
      color: white,
      _focusVisible: {
        outlineWidth: 1,
        outlineColor: white,
      },
    },
  },
})
